import { useNavigate, useSearchParams } from "react-router-dom";
import { info, User } from "../../Public/assets/index";
import React, { useEffect } from "react";
import SignUpFlow from "../../Container/Auth/Layout";
import { useAuth } from "../../hooks";

function AccountDetected() {
  const navigate = useNavigate();
  const { userList, setUserName } = useAuth();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";

  useEffect(() => {
    if (!userList?.usernameList || userList.usernameList.length === 0) {
      // Use replace to avoid stacking invalid route in history
      navigate(`/?email=${encodeURIComponent(email)}`, { replace: true });
    } else if (userList.usernameList.length === 1) {
      setUserName(userList.usernameList[0]);
      navigate(`/login?email=${encodeURIComponent(email)}`, { replace: true });
    }
  }, [userList, email, navigate, setUserName]);

  return (
    <SignUpFlow
      headerText={"Accounts detected"}
      ParagraphText={
        "We've found the following usernames linked to your email address:"
      }
    >
      <p className="flex gap-3 bg-greyShade rounded-[8px] leading-[20px] p-4 mb-4 font-geomanistRegular text-[14px] text-greyish">
        <img src={info} alt="" />
        Please log in to link an existing account or use another email.
      </p>

      {userList?.usernameList?.slice(0, 5).map((user, index) => (
        <div
          key={index}
          className="flex items-center justify-between border-[1px] border-greyShade p-3 rounded-md mb-2"
        >
          <span className="flex w-[80%] gap-2 items-center font-geomanistBold text-[16px] leading-[20px] overflow-hidden">
            <img src={User} alt="" />
            {user}
          </span>
          <button
            className="font-geomanistBold w-[20%] bg-white z-99 pl-3 text-[14px] text-blueish hover:pointer"
            onClick={() => {
              setUserName(user);
              navigate(`/login?email=${encodeURIComponent(email)}`);
            }}
          >
            Login
          </button>
        </div>
      ))}

      <p className="text-center font-geomanistMedium text-[18px] my-4">OR</p>
      <div className="w-full flex justify-center">
        <button
          className="px-10 bg-blueish text-white py-[10px] rounded-md font-geomanistMedium leading-[23px] text-[18px] hover:cursor-pointer"
          onClick={() => {
            navigate(`/email?email=${encodeURIComponent(email)}`);
          }}
          aria-label="Use another email to proceed"
        >
          Use Another Email
        </button>
      </div>
    </SignUpFlow>
  );
}

export default AccountDetected;
